import { MktPreferencesResponse } from '@cp-mx/common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { fetchMyMktPreferences } from './MyMktPreferencesSlice';
import { MyMktPreferencesSelector } from './MyMktPreferencesSelector';

export function useMyMktPreferences(): AbstractDataState<MktPreferencesResponse, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchMyMktPreferences, MyMktPreferencesSelector);
}
